export const audioType = 'audio';
